<div  class="d-flex w-100">
    <div class="binst-container d-flex flex-column w-50">
        <binsta-header-bar class="bg-grey"></binsta-header-bar>
        <div class="bg-grey w-100 d-flex column-holder">
            <div (mouseenter)="setChatHovered(true)"
                 (mouseleave)="setChatHovered(false)"
                 class="left-pane"
                 [class.left-pane-active]="leftPaneActive && !chatsBarHovered"
                 [class.left-pane-hovered]="chatsBarHovered && leftPaneActive"]
            >
                <router-outlet name="left-pane"></router-outlet>
            </div>
            <div class="bg-grey binst-window w-100 overflow-hidden"
                 [ngClass]="{
                    'binst-window-left-pane-active': leftPaneActive && !rightPaneActive,
                    'binst-window-right-pane-active': rightPaneActive && !leftPaneActive,
                    'binst-window-both-active': leftPaneActive && rightPaneActive
                 }"
            >
                <canvas class="w-100" #canvas id="canvas" ></canvas>
                <div class="chat-holder-overlay">
                    <router-outlet name="chat-pane"></router-outlet>
                </div>
                <div class="bontroller-holder-overlay">
                    <div class="new-modal-pane new-modal-pane-active">
                        <router-outlet name="new-modal-pane"></router-outlet>
                    </div>
                    <div class="bontroller-holder">
                        <binsta-bontroller></binsta-bontroller>
                    </div>
                    <!--            <div class="new-holder d-flex justify-content-end">-->
                    <!--                <binsta-new-holder> </binsta-new-holder>-->
                    <!--            </div>-->
                </div>
            </div>
            <div class="bg-grey right-pane " [class.right-pane-active]="rightPaneActive">
                <router-outlet name="right-pane"></router-outlet>
            </div>
            <context-menu></context-menu>
        </div>
    </div>
    <div class="canvass w-50" #container>

    </div>
</div>
